<template>
  <div class='page'>
    <div class='page-content'>
         <!-- 列表数据 -->
         <el-tabs v-model="activeName" @tab-click="tabClick" type="border-card">
           <el-tab-pane label="补贴凭证信息" name="subsidy" >
           <el-table
            height='100%'
            :data="shopBrandList"
            row-key="id"
            @selection-change="handleSelectionChange"
            size="small"
            v-loading="loading"
            border
          >
           <div >
             <el-table-column
                 :show-overflow-tooltip="true"
                 align="center"
                 prop="money1"
                 label="消费凭证"
                 min-width="20%"
               >
              </el-table-column>
             <el-table-column
                 :show-overflow-tooltip="true"
                 align="center"
                 prop="money2"
                 label="贡献值"
                 min-width="20%"
               >
              </el-table-column>
             <el-table-column
                 :show-overflow-tooltip="true"
                 align="center"
                 prop="money3"
                 label="消费券额度"
                 min-width="20%"
               >
              </el-table-column>
             <el-table-column
                 :show-overflow-tooltip="true"
                 align="center"
                 prop="money4"
                 label="动券宝额度"
                 min-width="20%"
               >
              </el-table-column>
             <el-table-column
                 :show-overflow-tooltip="true"
                 align="center"
                 prop="firstRatio"
                 label="第一期比例"
                 min-width="20%"
               >
              </el-table-column>
             <el-table-column
                 :show-overflow-tooltip="true"
                 align="center"
                 prop="serviceRatio"
                 label="服务费比例"
                 min-width="20%"
               >
              </el-table-column>
             <el-table-column
                 :show-overflow-tooltip="true"
                 align="center"
                 prop="orderMoney"
                 label="消费金额"
                 min-width="20%"
               >
              </el-table-column>
             <el-table-column
                 :show-overflow-tooltip="true"
                 align="center"
                 prop="periods"
                 label="期数"
                 min-width="20%"
               >
              </el-table-column>
             <el-table-column
                 :show-overflow-tooltip="true"
                 align="center"
                 prop="lastMoney"
                 label="最后一期补贴金额"
                 min-width="20%"
               >
              </el-table-column>
             <el-table-column
                 :show-overflow-tooltip="true"
                 align="center"
                 prop="isOver"
                 label="是否结束"
                 min-width="20%"
               >
               <template slot-scope="scope"> 
                 <div>
                    {{ scope.row.isOver == 1 ? '是' : '否' }}   
                 </div>
               </template>
              </el-table-column>
              <el-table-column
                 :show-overflow-tooltip="true"
                 align="center"
                 prop="totalMoney"
                 label="共计补贴金额"
                 min-width="20%"
               >
              </el-table-column>
           </div>
          </el-table>
          </el-tab-pane>

         <el-tab-pane label="资金流水信息" name="flowingWater" >
          <el-table
            height='100%'
            :data="shopBrandList"
            row-key="id"
            @selection-change="handleSelectionChange"
            size="small"
            v-loading="loading"
            border
          >
           <div>
                 <el-table-column :show-overflow-tooltip="true" align="center" label="货币类型" min-width="20%">
                      <template slot-scope="scope">
                          {{ getCurrecyType(scope.row.flowType) }}
                      </template>
                  </el-table-column>
                  <el-table-column :show-overflow-tooltip="true" align="center" prop="userMobile" label="手机号" min-width="20%">
                    </el-table-column>
                  <el-table-column :show-overflow-tooltip="true" align="center" prop="originalMoney" label="动账前金额" min-width="20%">
                  </el-table-column>
                  <el-table-column :show-overflow-tooltip="true" align="center" label="操作方向" min-width="20%">
                      <template slot-scope="scope">
                          {{ getOrientation(scope.row.flowOrientation) }}
                      </template>
                  </el-table-column>
                  <el-table-column :show-overflow-tooltip="true" align="center" prop="money" label="金额" min-width="20%"> </el-table-column>
                  <el-table-column :show-overflow-tooltip="true" align="center" prop="restMoney" label="动账后金额" min-width="20%"> </el-table-column>
                  <el-table-column width="300px"  align="center" prop="flowDetail" label="资金流水记录描述"> </el-table-column>
             </div>
          </el-table>
          </el-tab-pane>
         <!-- <el-tab-pane label="资金记录信息" name="record">
          <el-table
            height='100%'
            :data="shopBrandList"
            row-key="id"
            @selection-change="handleSelectionChange"
            size="small"
            v-loading="loading"
            border
          >
            <div>
                <el-table-column
                    align="center"
                    prop="recordType"
                    label="记录类型"
                    :show-overflow-tooltip="true"
                    min-width="20%"
                    >
                    <template slot-scope="scope">
                      {{ recordTypeValue(scope.row.recordType) }}
                    </template>
                  </el-table-column>
                    <el-table-column
                  :show-overflow-tooltip="true"
                  align="center"
                  prop="money"
                  label="金额"
                  min-width="20%"
                  >
                </el-table-column>
                <el-table-column
                  :show-overflow-tooltip="true"
                    align="center"
                    prop="recordStatus"
                    label="记录状态"
                    min-width="20%"
                    >
                    <template slot-scope="scope">
                      {{ recordStatusValue(scope.row.recordStatus) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                      :show-overflow-tooltip="true"
                        align="center"
                        prop="currencyType"
                        label="货币类型"
                        min-width="20%"
                      >
                      <template slot-scope="scope">
                      {{scope.row.currencyType == 1 ? "余额" : scope.row.currencyType == 8 ? "消费券额度 " :"动券宝额度" }}
                    </template>
                </el-table-column>
                <el-table-column
                  :show-overflow-tooltip="true"
                  align="corner"
                  prop="recordDetail"
                  label="记录明细"
                  min-width="60%"
                  >
                </el-table-column>
            </div>
           </el-table>
          </el-tab-pane> -->
        </el-tabs>
        <!-- <div class="pagination-box">
           <el-pagination
             @size-change="sizeChange"
             @current-change="currentChange"
             :current-page.sync="currentPage"
             :page-sizes="[10, 20, 50, 100]"
             :page-size="pageSize"
             layout="total, sizes, prev, pager, next, jumper"
             :total="totalNum"
             background
             :pager-count="7"
           >
           </el-pagination>
         </div> -->
      
    </div>
  </div>
</template>
<script>
import { Refresh, Search } from '@v2icons/tabler';
import { get, post, deleteFun, upload } from '@/utils/request.js';
import GridSelectShop from '@/components/gridselect/gidselect.vue';
import GridSelectU from '@/components/gridselect/index.vue';
export default {
  components: {
    Refresh,
    Search,
    GridSelectShop,
    GridSelectU
  },
  props: { 
    detailedQueryRow:{
       type: Object,
       default: () => {
         return {}
       }
    }
  },
  data() {
    return {
      activeName:'subsidy',
      queryForm: {
                orderNumber: '', // 订单编号
                shopId: '', // 店铺ID
                userId: '', // 用户ID

            },
            loading: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            multipleSelection: [],
            shopBrandList: [],//列表数据
            resObj:{},//接口数据
            flowOrientationList: [], //操作类型
            flowTypeList: [], //流水类型
        };
    },
    created() {
        this.getBrandList();
        this.getFlowOrientationList()
        this.getFlowTypeList()
    },
    methods: {
            //获取流水类型
        getFlowTypeList() {
            get(`/mpp/utils/getEnum`, { enumType: `currency_type` }).then((res) => {
                if (res.success) {
                    this.flowTypeList = res.enumList;
                }
            });
        },
        //获取货币类型
       getCurrecyType(type) {
            for (const index in this.flowTypeList) {
                if (this.flowTypeList[index].key == type) {
                    return this.flowTypeList[index].value;
                }
            }
        },
         getOrientation(orientation) {
            for (const index in this.flowOrientationList) {
                if (this.flowOrientationList[index].key == orientation) {
                    return this.flowOrientationList[index].value;
                }
            }
        },
        //获取操作类型
        getFlowOrientationList() {
            get(`/mpp/utils/getEnum`, { enumType: `money_flow_orientation` }).then((res) => {
                if (res.success) {
                    this.flowOrientationList = res.enumList;
                }
            });
        },
        recordTypeValue(row){
          // 1:充值 2:消费 3:收入 4:提现 5:转出 6:转入 7:兑出 8:兑入 9:赠送 10:抵扣 11:释放 12:锁仓
           let recordType = ''
           switch (row) {
            case 1:
              recordType = "充值"
            break;
            case 2:
              recordType = "消费"
            break;
            case 3:
              recordType = "收入"
            break;
            case 4:
              recordType = "提现"
            break;
            case 5:
              recordType = "转出"
            break;
            case 6:
              recordType = "转入"
            break;
            case 7:
              recordType = "兑出"
            break;
            case 8:
              recordType = "兑入"
            break;
            case 9:
              recordType = "赠送"
            break;
            case 10:
              recordType = "抵扣"
            break;
            case 11:
              recordType = "释放"
            break;
            case 12:
              recordType = "锁仓"
            break;
            default:
              break;
           }
           return recordType
        },
        recordStatusValue(row){
          // 记录状态(1:待结算 2:已结算 3:冻结中 4:已退款 5:审核中 6:审核成功 7:审核失败)
           let recordStatus = ''
           switch (row) {
            case 1:
              recordStatus = "待结算"
            break;
            case 2:
              recordStatus = "已结算"
            break;
            case 3:
              recordStatus = "冻结中"
            break;
            case 4:
              recordStatus = "已退款"
            break;
            case 5:
              recordStatus = "审核中"
            break;
            case 6:
              recordStatus = "审核成功"
            break;
            case 7:
              recordStatus = "审核失败"
            break;
            default:
              break;
           }
           return recordStatus;
        },
        tabClick(){
          if(this.activeName == 'subsidy'){
                this.shopBrandList = this.resObj.voucher;
          }else if(this.activeName == 'flowingWater'){
              this.shopBrandList = this.resObj.flow;
          }else if(this.activeName == 'record'){
              this.shopBrandList = this.resObj.record;
          }
        },
        // 列表数据请求
        getBrandList() {
            this.loading = true;
            get(`/shop/simulated/queryById`, {
                 id:this.detailedQueryRow.id
                // pageNum: this.currentPage,
                // pageSize: this.pageSize
            }).then((res) => {
              if (res.success) {
                  this.loading = false;
                  this.resObj = res;
                  if(this.activeName == 'subsidy'){
                      this.shopBrandList  = res.voucher
                  }
                  // this.totalNum = res.total;
                }
            });
        },
     
      
      
        
        handleSelectionChange(value) {
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getBrandList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getBrandList();
        },
    }
};
</script>
 
<style scoped>
  
</style>